import {Box, Skeleton} from "@mui/material";
import {HTMLAttributes} from "react";
import {useTranslation} from "react-i18next";

interface Props {
    /** The Autocomplete's option props (without the key). */
    optionProps: HTMLAttributes<HTMLLIElement>
    name: string
    /** "60 min · Massages" */
    detail?: string
    /** The service's rate price on the line's date, formatted; undefined without a rate. */
    price?: string
    priceLoading: boolean
}

/** A service in the picker: its name, duration and category below, its price on the line's date right. */
const FolioServiceOption = ({optionProps, name, detail, price, priceLoading}: Props) => {
    const {t} = useTranslation();

    return (
        <Box component={'li'} {...optionProps} sx={{gap: 1.5}}>
            <Box sx={{flex: 1, minWidth: 0}}>
                <Box sx={{fontSize: 14, lineHeight: '20px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                    {name}
                </Box>
                {!!detail && (
                    <Box sx={{fontSize: 12, lineHeight: '16px', color: 'text.secondary', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                        {detail}
                    </Box>
                )}
            </Box>
            <Box sx={{flexShrink: 0, fontSize: 13, fontWeight: 600, fontVariantNumeric: 'tabular-nums', color: price ? 'text.primary' : 'warning.dark'}}>
                {priceLoading ? <Skeleton width={48} height={18}/> : price ?? t('No rate')}
            </Box>
        </Box>
    );
};

export default FolioServiceOption;
